if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    connectedCallback() {
      try {
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      } catch (e) {
        this.variants = [];
      }

      this.idInput = this.querySelector('[data-variant-id-input]');
      this.priceCurrent = this.querySelector('[data-price-current]');
      this.atc = this.querySelector('[data-atc]');
      this.atcText = this.querySelector('[data-atc-text]');
      this.selectedLabel = this.querySelector('[data-selected-option]');
      this.soldOutText = this.atcText ? this.atcText.dataset.soldout : null;

      this.gallery = document.querySelector('[data-gallery]');

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-variant-id]')) {
          this.onVariantChange(e.target.value, e.target.dataset.variantTitle);
        }
      });
    }

    onVariantChange(id, title) {
      const variant = this.variants.find((v) => String(v.id) === String(id));
      if (!variant) return;

      if (this.idInput) this.idInput.value = variant.id;
      if (this.selectedLabel && title) this.selectedLabel.textContent = title;

      if (this.priceCurrent) this.priceCurrent.textContent = variant.price;

      if (this.atc) {
        this.atc.disabled = !variant.available;
        if (this.atcText) {
          this.atcText.textContent = variant.available
            ? this.atcText.dataset.add
            : this.atcText.dataset.soldout;
        }
      }

      if (variant.media_id && this.gallery) {
        this.gallery.dispatchEvent(
          new CustomEvent('gallery:select', { detail: { mediaId: variant.media_id } })
        );
      }

      if (history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }
  }

  customElements.define('product-form', ProductForm);
}

/* ---------- Gallery ---------- */
(function () {
  const gallery = document.querySelector('[data-gallery]');
  if (!gallery) return;

  const track = gallery.querySelector('[data-gallery-main]');
  // Slides are the unit of navigation (one image each; the model video lives
  // in its own section further down the page, not in the gallery).
  const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
  const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
  const dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
  let current = 0;

  // Deferred gallery images carry their URL in data-srcset/data-src (only the
  // first image loads up front). Hydrate one on demand — set srcset BEFORE src
  // so the browser makes a single, correctly-sized request. Idempotent.
  function hydrate(img) {
    if (!img) return;
    if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
    if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
  }

  function hydrateSlide(index) {
    const slide = slides[index];
    if (!slide) return;
    hydrate(slide.querySelector('[data-gallery-image]'));
  }

  // Mark a slide current (dots/thumbs + hydration) without moving the track —
  // the track position is owned by native snap scrolling.
  function markActive(index) {
    current = index;
    // Load the target plus its immediate neighbours so the next swipe/arrow
    // always lands on an already-loading image.
    hydrateSlide(index);
    hydrateSlide((index + 1) % slides.length);
    hydrateSlide((index - 1 + slides.length) % slides.length);
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
      const img = slide.querySelector('[data-gallery-image]');
      if (img) img.classList.toggle('is-active', i === index);
    });
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    windowDots(index);
  }

  // Dots overflow guard: each dot is a fixed 12px step, so 17 dots need
  // ~204px — fine down to 360. If a product ever carries more dots than the
  // row can hold, show a sliding window around the current one (standard
  // pattern) instead of shrinking or wrapping them.
  const dotsWrap = gallery.querySelector('[data-gallery-dots]');
  function windowDots(index) {
    if (!dotsWrap || !dots.length) return;
    const step = dots[0].offsetWidth || 12;
    const max = Math.max(5, Math.floor(dotsWrap.clientWidth / step));
    if (dots.length <= max) {
      dots.forEach((d) => { d.hidden = false; });
      return;
    }
    let start = Math.max(0, index - Math.floor(max / 2));
    start = Math.min(start, dots.length - max);
    dots.forEach((d, i) => { d.hidden = i < start || i >= start + max; });
  }

  // Programmatic navigation (arrows, dots, thumbs, variant sync): scroll the
  // snap track to the slide; markActive runs immediately so the indicators
  // and hydration don't wait for the smooth scroll to settle. While the
  // smooth scroll is in flight the scroll listener is suppressed, so a long
  // jump (variant sync across many slides) neither flickers the dots through
  // every intermediate index nor hydrates every image it glides past.
  let settling = 0;
  function activate(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    markActive(index);
    if (!track) return;
    clearTimeout(settling);
    settling = setTimeout(() => { settling = 0; }, 1000);
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: index * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
  }

  if (track) {
    // Native touch swipe moves the track; keep the indicators + hydration in
    // sync from the scroll position (rAF-throttled — fires early enough
    // during the gesture that the incoming slide starts loading before it
    // settles).
    let raf = 0;
    track.addEventListener('scroll', () => {
      if (settling || raf) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        if (settling) return;
        const idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== current && idx >= 0 && idx < slides.length) markActive(idx);
      });
    }, { passive: true });

    // A settled programmatic scroll re-enables the listener early; a touch
    // takes control back immediately and warms up the next slide so the very
    // first swipe already finds its image loading.
    track.addEventListener('scrollend', () => {
      clearTimeout(settling);
      settling = 0;
    });
    track.addEventListener('touchstart', () => {
      clearTimeout(settling);
      settling = 0;
      hydrateSlide(Math.min(current + 1, slides.length - 1));
    }, { passive: true });
  }

  if (dots.length) window.addEventListener('resize', () => windowDots(current), { passive: true });

  thumbs.forEach((t) => {
    t.addEventListener('click', () => activate(Number(t.dataset.index)));
  });
  dots.forEach((d) => {
    d.addEventListener('click', () => activate(Number(d.dataset.index)));
  });

  const prev = gallery.querySelector('[data-gallery-prev]');
  const next = gallery.querySelector('[data-gallery-next]');
  if (prev) prev.addEventListener('click', () => activate(current - 1));
  if (next) next.addEventListener('click', () => activate(current + 1));

  // Variant → gallery sync: activate the slide holding the variant's image.
  gallery.addEventListener('gallery:select', (e) => {
    const idx = slides.findIndex((slide) => {
      const img = slide.querySelector('[data-gallery-image]');
      return img && String(img.dataset.mediaId) === String(e.detail.mediaId);
    });
    if (idx !== -1) activate(idx);
  });
})();


/* ---------- Quantity stepper ---------- */
(function () {
  document.querySelectorAll('[data-qty-input]').forEach((input) => {
    const wrap = input.closest('.product-page__qty');
    if (!wrap) return;
    const minus = wrap.querySelector('[data-qty-minus]');
    const plus = wrap.querySelector('[data-qty-plus]');
    const clamp = () => {
      let v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      input.value = v;
    };
    if (minus) minus.addEventListener('click', () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) + 1; });
    input.addEventListener('change', clamp);
  });
})();

/* ---------- Sticky add-to-cart bar ---------- */
// LF-style bottom bar (sections/product.liquid, [data-sticky-bar]). Owns NO
// cart logic: the tap is forwarded to the main [data-bundle-atc] button, so
// the add is <bundle-offer>'s own addBundle() (same selected offer, same
// dropdown variants, same _busy guard, same cart-drawer open). Price, label,
// disabled and loading state are mirrored from the offer card / main button.
(function () {
  var bar = document.querySelector('[data-sticky-bar]');
  if (!bar || !('IntersectionObserver' in window)) return;
  var host = document.querySelector('bundle-offer');
  var mainAtc = host && host.querySelector('[data-bundle-atc]');
  if (!host || !mainAtc) return;

  var mainText = host.querySelector('[data-bundle-atc-text]');
  var btn = bar.querySelector('[data-sticky-atc]');
  var btnText = bar.querySelector('[data-sticky-atc-text]');
  var priceEl = bar.querySelector('[data-sticky-price]');
  var wasEl = bar.querySelector('[data-sticky-was]');
  var root = document.documentElement;

  if (btn) {
    btn.addEventListener('click', function () {
      // A disabled main button (sold out / empty slot / busy) never fires.
      if (!mainAtc.disabled) mainAtc.click();
    });
  }

  function syncButton() {
    if (!btn) return;
    btn.disabled = mainAtc.disabled;
    btn.classList.toggle('is-loading', mainAtc.classList.contains('is-loading'));
    if (mainText && btnText) btnText.textContent = mainText.textContent.trim();
  }

  // The selected offer's price = the active card's own (live) price framing,
  // kept current by mix-match.js; the bar only mirrors it.
  function syncPrice() {
    var checked = host.querySelector('[data-offer-radio]:checked');
    var offer = checked ? checked.value : '2';
    var now = host.querySelector('[data-price-' + offer + ']');
    var was = host.querySelector('[data-price-' + offer + '-was]');
    if (priceEl && now) priceEl.textContent = now.textContent.trim();
    if (wasEl) wasEl.textContent = was ? was.textContent.trim() : '';
  }

  var queued = 0;
  function sync() {
    if (queued) return;
    queued = requestAnimationFrame(function () {
      queued = 0;
      syncButton();
      syncPrice();
    });
  }
  new MutationObserver(sync).observe(host, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['disabled', 'class']
  });
  host.addEventListener('change', sync);
  sync();

  // Bottom offset for Shopify's cookie/privacy banner when it is showing, and
  // the bar's total height (published as page bottom padding while visible).
  function bannerHeight() {
    var el = document.getElementById('shopify-pc__banner');
    if (!el || !el.offsetHeight) return 0;
    var rect = el.getBoundingClientRect();
    return rect.bottom >= window.innerHeight - 1 ? rect.height : 0;
  }
  function measure() {
    var off = bannerHeight();
    root.style.setProperty('--sticky-bar-offset', off + 'px');
    root.style.setProperty('--sticky-bar-h', (bar.offsetHeight + off) + 'px');
  }

  var visible = false;
  function setVisible(v) {
    if (v === visible) return;
    visible = v;
    if (v) measure();
    bar.classList.toggle('is-visible', v);
    document.body.classList.toggle('has-sticky-bar', v);
  }

  // Shown once the main button has scrolled above the TOP THIRD of the
  // viewport — while it is still on screen near the top, not only after it
  // has left entirely — and hidden again as soon as it comes back below that
  // line. The -33% top margin moves the observer's top edge down to that
  // third; the bottom is still extended far below, so "intersecting" means
  // "below the line" and the ONLY state change is at the line itself — a fast
  // flick that carries the button past it within a single frame still crosses
  // it (a plain threshold:0 observer never fires for below -> above, since
  // both states are "not intersecting").
  new IntersectionObserver(function (entries) {
    setVisible(!entries[entries.length - 1].isIntersecting);
  }, { rootMargin: '-33% 0px 100000px 0px', threshold: 0 }).observe(mainAtc);

  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(bar);
  window.addEventListener('resize', measure);
  // The privacy banner is injected after load — re-measure when body children change.
  new MutationObserver(measure).observe(document.body, { childList: true });
  measure();
})();
